
Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Sidebar = {

    options: [
        'PICKLIST',
        'PICKLIST_MULTISELECT',
        'TEXT_AREA',
        'TEXT',
        'INT',
        'DATE',
        'DATE_TIME',
        'TIME',
        'DECIMAL',
        'RATING',
        'CHECKBOX',
        'ENTITY',
        'SIGNATURE'
    ],

    createQuestionToSection: function (sectionID, parentQuestionId) {
        this.createOverlay();
        this.createSideList(null, parentQuestionId);
        this.addButtonGroupListeners(sectionID, null, parentQuestionId);
    },

    editQuestion: function (questionId, parentQuestionId) {
        this.createOverlay();
        this.createSideList(questionId, parentQuestionId);
        this.updateOverlayForQuestion(questionId, parentQuestionId);
        this.addButtonGroupListeners(null, questionId, parentQuestionId);
    },

    createOverlay: function () {
        var popupElement        = document.querySelector('#Survey'),
            questionFormOverlay = document.createElement('div'),
            questionFormContent = document.createElement('div'),
            helper              = new Monet.UI.Help('SurveyQuestion', Monet.I18n.getResourcesByKey('survey.userinterface.description'));

        questionFormOverlay.id = 'SurveyLinkOverlay';
        questionFormContent.id = 'SurveyLinkForm';
        questionFormContent.appendChild(Greenmile.Survey.Templates.SurveyCreateQuestionTemplate());
        let formContent = questionFormContent.querySelector('#SurveyLinkForm .formContent');

        questionFormContent.querySelector('.buttonGroup.standard-form-buttons').appendChild(helper.render());
        popupElement.appendChild(questionFormOverlay);
        popupElement.appendChild(questionFormContent);
    },

    createOverlayAfterReleased: function () {

        this.createOverlayAfterReleasedPickList();

    },


    createOverlayAfterReleasedPickList: function () {

        var popupElement        = document.querySelector('#Survey'),
            questionFormOverlay = document.createElement('div'),
            questionFormContent = document.createElement('div');

        questionFormOverlay.id = 'SurveyLinkOverlay';
        questionFormContent.id = 'SurveyLinkForm';
        questionFormContent.appendChild(Greenmile.Survey.Templates.SurveyAnswerTemplateAfterReleased());

        popupElement.appendChild(questionFormOverlay);
        popupElement.appendChild(questionFormContent);

    },

    updateOverlayForQuestion: function (questionID, parentQuestionId) {

        var question = Greenmile.Survey.Data.findQuestion(questionID),
            sideItem = question.questionObject;

        sideItem.type = question.questionType;
        this.clearListSelection();
        this.changeQuestionContent(sideItem, question, parentQuestionId);

        if (sideItem.prepareForUpdate) {
            sideItem.prepareForUpdate(question);
        }
    },

    createSideList: function (questionId, parentQuestionId) {
        var ul       = document.createElement('ul'),
            sidebar  = document.querySelector('#Survey #SurveyLinkForm .sidebar'),
            i,
            question = Greenmile.Survey.Data.findQuestion(questionId);

        for (i = 0; i < this.options.length; i++) {

            var itemName = this.options[i],
                sideItem = Greenmile.Survey.SidebarFactory.factoryItemFromJsonType(itemName),
                li       = document.createElement('li');

            if (question && question.questionObject.jsonType === itemName) {
                sideItem = question.questionObject;
                li.className = 'sideMenuItem currentItem'
            }

            li.innerHTML = Monet.I18n.getResourcesByKey(sideItem.resourceKey);
            sideItem.type = itemName;
            this.addItemListener(li, sideItem, questionId, parentQuestionId);

            ul.appendChild(li);

        }

        sidebar.appendChild(ul);
    },

    addItemListener: function (li, sideItem, questionId, parentQuestionId) {
        li.addEventListener('click', (function (scope, questionId) {
            return function () {
                if (!Greenmile.Survey.Sidebar.sideObject){
                    Greenmile.Survey.Sidebar.sideObject = Greenmile.Survey.Data.findQuestion(questionId);
                }

                const enableToChangeQuestion = () => {
                    scope.clearErrorMessage();
                    scope.clearListSelection();
                    scope.changeQuestionContent(sideItem, questionId, parentQuestionId);

                    const u = li.parentNode;
                    const lis = u.childNodes;
                    for (let i = 0; i < lis.length; i++) {
                        lis[i].className = '';
                    }
                    $(li).addClass('sideMenuItem');
                    $(li).addClass('currentItem');

                    Greenmile.Survey.Sidebar.sideObject = sideItem;
                };

                if (questionId && Greenmile.Survey.Sidebar.sideObject.questionType !== sideItem.questionType) {

                    new Greenmile.Components.AlertModal("smartSurvey.changeQuestionContent",
                        null,
                        enableToChangeQuestion)
                    .show();

                } else if (!questionId) {

                    enableToChangeQuestion();
                }

            };
        }(this, questionId)));
    },

    clearListSelection: function () {
        var itemsList = document.querySelectorAll('#Survey #SurveyLinkForm .sidebar li'),
            i;

        for (i = 0; i < itemsList.length; i++) {
            var li = itemsList[i];
            li.className = li.className.replace('selected', '');
        }
    },

    changeQuestionContent: async function (sideItem, question, parentQuestionId) {
        var content = document.querySelector('#Survey #SurveyLinkForm .questionContent');

        content.innerHTML = "";
        content.appendChild(Greenmile.Survey.Templates.Sidebar[sideItem.templateID]({ type: sideItem.type, hideDefaultAnswer: sideItem.hideDefaultAnswer }));

        if (sideItem.didRenderTemplate) {
            await sideItem.didRenderTemplate(question, parentQuestionId);
        }

        if (question && question.question) {
            var title = document.querySelector('#SurveyLinkForm .questionContent input[type="text"]');
            title.value = question.question;
        }
    },

    checkHasDuplicates: function (arr) {

        var cache = [], result = false;

        for (var i in arr) {
            var value = arr[i].value.trim().toUpperCase();
            if (cache.indexOf(value) === -1) {
                cache.push(value);
            } else {
                result = true;
                break;
            }
        }

        return result;
    },

    answerCropExceedLength: function (arrayStrings, maxSize) {

        var __arrayStrings = arrayStrings;
        var __arrayStringsLength = __arrayStrings.length;

        if (__arrayStringsLength) {

            for (var i = 0; i < __arrayStringsLength; i++) {

                var text = __arrayStrings[i].value;

                if (text.length > maxSize) {

                    __arrayStrings[i].value = text.substr(0, maxSize);

                }

            }
        }

        return __arrayStrings;
    },

    addButtonGroupListeners: function (sectionID, questionID, parentQuestionId) {
        var saveButton   = document.querySelector('#LinkFormSaveButton'),
            cancelButton = document.querySelector('#LinkFormCancelButton');

        saveButton.addEventListener('click', (function (scope) {

            return function () {
                var hiddenType   = document.getElementsByName('questionType')[0],
                    errors       = [],
                    sideItem,
                    input,
                    questionData = Greenmile.Survey.Data.findQuestion(questionID);

                scope.clearErrorMessage();

                if (hiddenType) {

                    var questionType = hiddenType.value;

                    sideItem = (questionData ? questionData.questionObject : Greenmile.Survey.Sidebar.sideObject);

                    if(hiddenType.value !== sideItem.type) {

                        questionData = null;
                        sideItem = Greenmile.Survey.Sidebar.sideObject;

                        input = sideItem.serializeInput(questionData);
                        errors = scope.getInvalidFieldsInput(input, questionData);

                        if (errors.length === 0) {

                            Greenmile.Survey.Form.doneEditingQuestionChangingType(questionID, input, sideItem, parentQuestionId);
                            scope.dismissQuestionForm();

                        } else {

                            scope.showErrors(errors);

                        }
                    }
                    else {

                        input = sideItem.serializeInput(questionData);

                        errors = scope.getInvalidFieldsInput(input, questionData);

                        if (errors.length === 0) {

                            input.questionData = input.questionData || questionData;

                            if (sectionID) {
                                Greenmile.Survey.Form.doneCreatingQuestion(sectionID, input, parentQuestionId, sideItem);
                            }

                            if (questionID) {
                                Greenmile.Survey.Form.doneEditingQuestion(questionID, input, parentQuestionId);
                            }

                            scope.dismissQuestionForm();

                        } else {

                            scope.showErrors(errors);

                        }
                    }

                } else {

                    errors.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.ChoiceATypeQuestion'));
                    scope.showErrors(errors);

                }
                if (errors.length === 0){

                    Greenmile.Survey.Sidebar.sideObject = null;

                }
            };
        }(this)));

        cancelButton.addEventListener('click', (function (scope) {
            return function () {
                scope.dismissQuestionForm();
                Greenmile.Survey.Sidebar.sideObject = null;
            };
        }(this)));
    },

    getInvalidFieldsInput: function (input, questionData) {
        var errorMessages = input.errors || [],
            answerOptions,
            i,
            option;

        if (!input.questionText) {
            errorMessages.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.QuestionTextEmpty'));
        }

        answerOptions = input.answerOptions;

        if (input.questionType !== 'ENTITY') {
            if (answerOptions) {

                for (i = answerOptions.length - 1; i >= 0; i--) {

                    option = answerOptions[i].value;

                    if (!option || option.trim() === '') {

                        answerOptions.splice(i, 1);

                    }

                }

                if (answerOptions.length === 0
                    && (!questionData
                    || input.questionType === 'PICKLIST_MULTISELECT'
                    || input.questionType === 'PICKLIST')) {

                    errorMessages.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.NoOptions'));

                }
            }
        } else {
            if (!input.entity) {
                errorMessages.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.EntityIsEmpty'));
            }
        }

        return errorMessages;

    },

    showErrors: function (errors) {
        var divErrors = document.querySelector('#Survey #SurveyLinkForm .formContent .monetInlineAlerContainer');
        var list = document.createElement('ul');
        list.className = 'alert alert-error';
        list.style.display = 'block';

        for (var i in errors) {
            if (errors.hasOwnProperty(i)) {

                var item = document.createElement('li');
                item.innerHTML = errors[i];
                list.appendChild(item);
            }
        }

        divErrors.appendChild(list);

    },

    clearErrorMessage: function () {

        var divErrors = document.querySelector('#Survey #SurveyLinkForm .formContent .monetInlineAlerContainer');

        if (divErrors && divErrors.firstChild) {
            divErrors.removeChild(divErrors.firstChild);
        }

    },

    dismissQuestionForm: function () {
      const formOverlay = document.querySelector('#SurveyLinkOverlay');
      const formContent = document.querySelector('#SurveyLinkForm');
      const overlayParent = formOverlay.parentNode;
      const formParent = formContent.parentNode;

      overlayParent.removeChild(formOverlay);
      formParent.removeChild(formContent);

      Greenmile.Survey.Form.verifyQuestionsToEnableActionButton();
    }

};
